import { useState } from "react";

import useComponentVisible from "./CloseOutSideClick";
import {
  ButtonPanelDiv,
  Container,
  OverlayPanelContainer,
} from "./PanelMoreOptionsStyles";

const PanelMoreOptions = (props) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const ref = useComponentVisible(() => setMenuOpen(false));
  return (
    <Container>
      <ButtonPanelDiv
        background={props.background}
        onClick={() => {
          setMenuOpen(!menuOpen);
        }}
      >
        <img src={props.img} alt="Detalles" />
      </ButtonPanelDiv>
      <OverlayPanelContainer
        active={menuOpen}
        ref={ref}
        width={props.width}
        height={props.height}
      >
        <div className="panel-children">{props.children}</div>
      </OverlayPanelContainer>
    </Container>
  );
};

export default PanelMoreOptions;
